/**
 * Environment configuration
 * This file manages all environment-specific configuration
 */

export const env = {
  // API Configuration
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,

  // Environment
  ENV: process.env.REACT_APP_ENV || "production",
  IS_PRODUCTION: process.env.REACT_APP_ENV === "production",
  IS_DEVELOPMENT: process.env.REACT_APP_ENV === "development",
  IS_STAGING: process.env.REACT_APP_ENV === "preview",
  IS_VERCEL: Boolean(process.env.VERCEL),

  // External Services
  PEXELS_API_KEY: process.env.REACT_APP_PEXELS_API_KEY,

  // WebSocket Configuration
  WS_URL: process.env.REACT_APP_WS_URL,
} as const;

// Type-safe config accessor
export const getConfig = () => {
  if (!env.API_BASE_URL) {
    throw new Error("API_BASE_URL is not configured. Please check your environment variables.");
  }

  return {
    apiBaseUrl: env.API_BASE_URL,
    pexelsApiKey: env.PEXELS_API_KEY,
    wsUrl: env.WS_URL,
  };
};

// Validate environment configuration
const validateConfig = () => {
  const requiredVars = ["REACT_APP_API_BASE_URL", "REACT_APP_ENV"];

  const recommendedVars = ["REACT_APP_PEXELS_API_KEY", "REACT_APP_WS_URL"];

  const missing = requiredVars.filter((name) => !(name in process.env));

  const missingRecommended = recommendedVars.filter((name) => !(name in process.env));

  if (missing.length > 0) {
    throw new Error(
      `Missing required environment variables: ${missing.join(", ")}\n` +
        "Please check your .env files or environment configuration."
    );
  }

  if (missingRecommended.length > 0 && !env.IS_PRODUCTION) {
    console.warn(
      `Missing recommended environment variables: ${missingRecommended.join(", ")}\n` +
        "Some features may not work as expected."
    );
  }
};

// Always validate configuration
validateConfig();
